import React from "react"
import classes from '../../Home/Home.module.css'

export const ContentLayout = ({ children }) => {
    return (
        <div className={classes.home}>
            {children}
        </div>
    )
}